import React from 'react';
import ProviderCard from './ProviderCard';
import ClientCard from './ClientCard';
import DocumentCard from './DocumentCard';
import LineItemsTable from './LineItemsTable';
import GenericCard from './GenericCard';
import GenericItemsTable from './GenericItemsTable';
import './ExtractedData.css';

function InvoiceLayout({ data, onChange, fieldsConfig }) {
  const showSection = (section) => !fieldsConfig || section in fieldsConfig;

  const proveedor = data.proveedor || {};
  const cliente = data.cliente || {};
  const documento = data.documento || {};
  const lineas = data.lineas || [];
  const totales = data.totales || {};

  const handleProveedorChange = (newProveedor) => {
    onChange({ ...data, proveedor: newProveedor });
  };

  const handleClienteChange = (newCliente) => {
    onChange({ ...data, cliente: newCliente });
  };

  const handleDocumentoChange = (newDocumento) => {
    onChange({ ...data, documento: newDocumento });
  };

  const handleLineasChange = (newLineas) => {
    onChange({ ...data, lineas: newLineas });
  };

  const handleTotalesChange = (newTotales) => {
    onChange({ ...data, totales: newTotales });
  };

  return (
    <>
      <div className="cards-grid">
        {showSection('proveedor') && <ProviderCard data={proveedor} onChange={handleProveedorChange} />}
        {showSection('cliente') && <ClientCard data={cliente} onChange={handleClienteChange} />}
        {showSection('documento') && <DocumentCard data={documento} onChange={handleDocumentoChange} />}
      </div>

      {showSection('lineas') && (
        <LineItemsTable
          items={lineas}
          totales={showSection('totales') ? totales : null}
          onItemsChange={handleLineasChange}
          onTotalesChange={showSection('totales') ? handleTotalesChange : undefined}
        />
      )}
    </>
  );
}

function CustomLayout({ data, onChange, fieldsConfig }) {
  const handleFieldChange = (partial) => {
    onChange({ ...data, ...partial });
  };

  return (
    <>
      {fieldsConfig.cards && fieldsConfig.cards.length > 0 && (
        <div className="cards-grid">
          {fieldsConfig.cards.map((card, i) => (
            <GenericCard
              key={i}
              title={card.title}
              fields={card.fields}
              data={data}
              onChange={handleFieldChange}
            />
          ))}
        </div>
      )}

      {fieldsConfig.table && (
        <GenericItemsTable
          title={fieldsConfig.table.title}
          itemsKey={fieldsConfig.table.key}
          fields={fieldsConfig.table.fields}
          columnOrder={fieldsConfig.table.column_order}
          totalsConfig={fieldsConfig.totals}
          data={data}
          onChange={handleFieldChange}
        />
      )}

      {fieldsConfig.notes && (
        <div className="notes-block">
          <label className="notes-label">{fieldsConfig.notes.label}</label>
          <textarea
            className="notes-textarea"
            value={data[fieldsConfig.notes.key] || ''}
            onChange={(e) => handleFieldChange({ [fieldsConfig.notes.key]: e.target.value })}
            rows={3}
          />
        </div>
      )}
    </>
  );
}

function ExtractedData({ data, onChange, fieldsConfig = null }) {
  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="no-data">
        <p>No se encontraron datos en el documento</p>
      </div>
    );
  }

  const isCustomLayout = fieldsConfig && (fieldsConfig.cards || fieldsConfig.table || fieldsConfig.totals);

  return (
    <div className="extracted-data">
      {isCustomLayout
        ? <CustomLayout data={data} onChange={onChange} fieldsConfig={fieldsConfig} />
        : <InvoiceLayout data={data} onChange={onChange} fieldsConfig={fieldsConfig} />
      }
    </div>
  );
}

export default ExtractedData;
